import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, TextField, Typography } from '@material-ui/core';
import { createStyles, StyledComponentProps, withStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import { EntityImage } from '../../comps/EntityImage';
import { IAdvertisement } from '../../main/entities';
import { transl } from '../../main/transl';
import { AdsPageStore } from './AdsPageStore';

const styles = createStyles({
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
	},
	paper: {
		minWidth: '50%',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
	},
	imageDiv: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		flex: '1 1',
		width: '100%',
		overflow: 'hidden',
	},
	image: {
		width: 'auto',
		height: 'auto',
		maxWidth: '80%',
		objectFit: 'contain',
		display: 'block',
		marginLeft: 'auto',
		marginRight: 'auto',
	},
	text: {
		margin: 10,
		width: '100%',
	},
	input: {
		margin: 10,
		width: '100%',
	},
});

interface IAdsDialogProps {
	entity: IAdvertisement | undefined
	store: Instance<typeof AdsPageStore>
}

@observer class _AdsDialog extends React.Component<IAdsDialogProps & StyledComponentProps> {
	_accept = () => this.props.store.accept()

	_cancel = () => this.props.store.setAdvertisementId(0)

	_onItemIdChange = e => this.props.store.setItemId(e.target.value)

	render() {
		const classes = this.props.classes || {};
		const {entity, store} = this.props;
		if (!entity) return null;
		return <Dialog open={true} className={classes.root} classes={{paper: classes.paper}} onClose={this._cancel}>
			<DialogTitle>{entity.name}</DialogTitle>
			<DialogContent className={classes.content}>
				<div className={classes.imageDiv}><EntityImage entity={entity} className={classes.image} tooltip=""/></div>
				<div className={classes.text}>{entity.description}</div>
				{
					store.variations.length<2 ? null :
						<TextField className={classes.input} select required
							label={transl('variation')}
							value={store.itemId}
							error={!store.itemId}
							onChange={this._onItemIdChange}>
							{store.variations.map(v => <MenuItem value={v.id} key={v.id}>{v.name || v.id}</MenuItem>)}
						</TextField>
				}
				{
					<TextField className={classes.input} select required
						label={transl('branch')}
						value={store.branchId}
						error={!store.branchId}
						onChange={e => store.setBranchId(+e.target.value)}
					>
						{store.branchInfos.map(x => <MenuItem value={x.branchId} key={x.branchId} disabled={!x.isAllowed}>
							{x.branchName}
						</MenuItem>)}
					</TextField>
				}
				{
					<TextField className={classes.input} select required
						label={transl('supplier')}
						value={store.templateId}
						error={!store.templateId}
						onChange={e => store.setTemplateId(+e.target.value)}
					>
						{store.filteredTemplatesInfos.map(x => <MenuItem value={x.templateId} key={x.templateId} disabled={!x.isAllowed}>
							{x.supplierName}
							<Typography display="inline" color="primary">
								{!transl('availability.' + x.availability) ? '' : ' → ' + transl('availability.' + x.availability)}
							</Typography>
						</MenuItem>)}
					</TextField>
				}
				{
					<TextField className={classes.input} type="number" required
						inputProps={{min: 0, max: entity.amountMax ? entity.amountMax : undefined, step: entity.amountStep}}
						label={transl('amountToOrder')}
						value={store.amountToOrder}
						onChange={e => store.setAmountToOrder(+e.target.value)}
					/>
				}
			</DialogContent>
			<DialogActions>
				<Button onClick={this._cancel}>{transl('cancel')}</Button>
				<Button onClick={this._accept} disabled={store.isDisabled} color="primary">{transl('addAdvertisementToCart')}</Button>
			</DialogActions>
		</Dialog>;
	}
}

export const AdsDialog = withStyles(styles)(_AdsDialog);
